import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bem, Button, ButtonType } from '@bifrost/web-components';
import { ReactComponent as UnknownIssue } from '@assets/500.svg';
import './error.styles.scss';
const cls = bem('bif-shell-error');
export const Error = (props) => {
    const { onBack } = props;
    return (_jsxs("div", { className: cls(), children: [_jsx("h3", { className: cls('__title'), children: "An error has occurred" }), _jsx("span", { className: cls('__description'), children: "We are sorry, an error has occurred that we could not resolve. Please return to the home page." }), _jsx(UnknownIssue, { className: cls('__icon') }), _jsx(Button.Root, { className: cls('__back'), type: ButtonType.SECONDARY, onClick: onBack, children: _jsx(Button.Text, { value: "Back to Home page" }) })] }));
};
